import { c as _c } from "react/compiler-runtime";
import { forwardRef } from 'react';
import { StyledCard, StyledLink } from './styles';
import { type CardProps } from './types';
import { CARD_CLASS_NAME } from './classNames';
const Card = forwardRef<HTMLDivElement, CardProps>((t0, ref) => {
  const $ = _c(19);
  let LinkProps;
  let children;
  let className;
  let disabled;
  let onClick;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      onClick,
      LinkProps,
      elevation: t1,
      disabled,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = LinkProps;
    $[2] = children;
    $[3] = className;
    $[4] = disabled;
    $[5] = onClick;
    $[6] = props;
    $[7] = t1;
  } else {
    LinkProps = $[1];
    children = $[2];
    className = $[3];
    disabled = $[4];
    onClick = $[5];
    props = $[6];
    t1 = $[7];
  }
  const elevation = t1 === undefined ? "flat" : t1;
  const isClickable = (onClick != null || LinkProps != null) && disabled !== true;
  const t2 = disabled !== true ? onClick : undefined;
  const t3 = `${CARD_CLASS_NAME} ${className ?? ""}`;
  let t4;
  if ($[8] !== children || $[9] !== elevation || $[10] !== isClickable || $[11] !== props || $[12] !== ref || $[13] !== t2 || $[14] !== t3) {
    t4 = <StyledCard {...props} ref={ref} onClick={t2} $isClickable={isClickable} elevation={elevation} className={t3}>{children}</StyledCard>;
    $[8] = children;
    $[9] = elevation;
    $[10] = isClickable;
    $[11] = props;
    $[12] = ref;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  const CardComponent = t4;
  let t5;
  if ($[16] !== CardComponent || $[17] !== LinkProps) {
    t5 = LinkProps != null ? <StyledLink {...LinkProps}>{CardComponent}</StyledLink> : CardComponent;
    $[16] = CardComponent;
    $[17] = LinkProps;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
});
export default Card;
export { Card };